<div class="d-flex align-items-center">
  <span
    >&copy; {{ settings.getAppSetting("year") }} - {{ settings.getAppSetting("name")
    }}<strong> | {{ "routes.dashboard.BETATEXT" | translate }} |</strong></span
  >
  <span class="ml-1"
    ><a class="text-muted" href="https://www.hxa.io/impressum/"
      >{{ "footer.IMPRINT" | translate }} |
    </a></span
  >
  <span class="ml-1"
    ><a class="text-muted" style="cursor: pointer" (click)="NavigateToPrivacy()">{{
      "footer.PRIVACY" | translate
    }}</a></span
  >
</div>
